// A chart made before signup lives in this browser until the person saves
// it to an account. Storage can be unavailable (private mode, blocked site
// data), so every access is guarded and the app works without it.

const KEY = "theweb.guestBirthData.v1";

export function loadGuestBirthData() {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function saveGuestBirthData(birthData) {
  try { window.localStorage.setItem(KEY, JSON.stringify(birthData)); } catch (e) { /* storage unavailable */ }
}

export function clearGuestBirthData() {
  try { window.localStorage.removeItem(KEY); } catch (e) { /* storage unavailable */ }
}
